<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div class="c-guests">
    <div class="columns is-multiline is-gapless">
      <div class="column is-hidden-tablet" style="margin-bottom: -4px">
        <div class="columns is-gapless is-mobile is-vcentered">
          <div class="column">
            <p class="is-uppercase">
              <strong class="has-text-grey"><small>Nomes</small></strong>
            </p>
          </div>
          <div class="column is-narrow">
            <router-link
              v-show="isClosed"
              :to="{
                name: 'rsvp-editar-convite',
                params: {
                  inviteId: rsvp.id,
                },
              }"
            >
              <button class="c-guests__edit mr-4">
                <base-icon
                  name="painel/icon-edit-list"
                  width="24"
                  height="25"
                />
              </button>
            </router-link>
          </div>
          <div class="column is-narrow">
            <GuestsDelete :rsvp="rsvp" />
          </div>
        </div>
      </div>
      <div class="column is-3">
        <div class="c-guests__label has-text-grey-darker">
          <p
            v-if="isClosed"
            class="has-text-grey-darker has-text-weight-bold c-guests__guest-description-title"
          >
            {{ rsvp.name }}
          </p>
          <p
            v-for="(guest, index) in rsvp.guests"
            class="c-guests__guest-description"
            :key="index"
          >
            {{ guest.name }}
          </p>
        </div>
      </div>

      <transition name="fade">
        <div
          v-show="show"
          :class="{ 'is-hidden-mobile': !show }"
          class="column c-guests__column is-2"
        >
          <p class="is-hidden-tablet">
            <strong class="is-uppercase has-text-grey">
              <small>Qtd. de convidados</small>
            </strong>
          </p>
          <div class="c-guests__label has-text-grey-darker">
            <p
              v-if="total > 0"
              class="has-text-grey-darker has-text-weight-bold c-guests__guest-description-title"
            >
              {{ total }} convidado<span v-if="total > 1">s</span>
            </p>
            <p class="c-guests__guest-description">
              {{ adults }} adulto<span v-if="adults > 1">s</span>
              <br />
              {{ children }} criança<span v-if="children > 1">s</span>
              <span v-if="isClosed">
                <br />
                {{ notInformed }} não informado<span v-if="notInformed > 1"
                  >s</span
                >
              </span>
            </p>
          </div>
        </div>
      </transition>

      <transition name="fade">
        <div
          v-show="show"
          :class="{ 'is-hidden-mobile': !show }"
          class="column c-guests__column is-3"
        >
          <p class="is-uppercase is-hidden-tablet">
            <strong class="has-text-grey">
              <small>Contato</small>
            </strong>
          </p>
          <div class="c-guests__label">
            <p>
              <span v-if="rsvp.email">{{ rsvp.email }}<br /></span>
              {{ rsvp.phone }}
            </p>
          </div>
        </div>
      </transition>

      <transition name="fade">
        <div
          v-show="show"
          :class="{ 'is-hidden-mobile': !show }"
          class="column c-guests__column"
        >
          <p class="is-uppercase is-hidden-tablet">
            <strong class="has-text-grey">
              <small>Confirmou em</small>
            </strong>
          </p>
          <div v-if="rsvp.date" class="c-guests__label">
            <p>{{ rsvp.date | dateWithoutHours }}</p>
          </div>
        </div>
      </transition>
      <div
        class="column is-hidden-mobile is-narrow has-text-right c-guests__button-edit"
      >
        <router-link
          v-show="isClosed"
          :to="{
            name: 'rsvp-editar-convite',
            params: {
              inviteId: rsvp.id,
            },
          }"
        >
          <button class="c-guests__edit">
            <base-icon name="painel/icon-edit-list" width="24" height="25" />
          </button>
        </router-link>
      </div>
      <div class="column is-hidden-mobile is-narrow has-text-right">
        <GuestsDelete :rsvp="rsvp" />
      </div>

      <transition name="fade">
        <div
          v-show="show"
          :class="{ 'is-hidden-mobile': !show }"
          class="column c-guests__column is-full"
        >
          <div style="margin-top: 1em" class="columns is-gapless is-mobile">
            <div class="column is-1 has-text-grey">
              <base-icon
                :class="{ 'has-text-primary': rsvp.obs }"
                style="margin-top: 5px"
                name="painel/chat-icon"
                width="18"
                height="18"
              />
            </div>
            <div v-if="rsvp.obs" class="column is-6-tablet">
              <p style="margin-left: 0.5em" class="is-italic">
                "<small>{{ rsvp.obs }}</small
                >"
              </p>
            </div>
          </div>
        </div>
      </transition>

      <transition name="fade">
        <div class="column is-hidden-tablet">
          <a @click="showAll" class="c-guests__link-details has-text-grey-dark">
            <base-icon
              v-if="show"
              name="painel/chevron-up-icon"
              width="14"
              height="14"
            />
            <base-icon
              v-else
              name="painel/chevron-down-icon"
              width="14"
              height="14"
            />
            <strong>Detalhes</strong>
          </a>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import GuestsDelete from '@/components/Rsvp/GuestsDelete.vue'

export default {
  props: {
    rsvp: {
      type: Object,
    },
  },

  components: {
    GuestsDelete,
  },

  computed: {
    isOpened() {
      return this.rsvp.mode === 'opened'
    },
    isClosed() {
      return this.rsvp.mode === 'closed'
    },
    adults() {
      if (this.isOpened) return this.rsvp.amount_adults || 0
      return this.rsvp.guests.filter((guest) => guest.type === 'adult').length
    },
    children() {
      if (this.isOpened) return this.rsvp.amount_children || 0
      return this.rsvp.guests.filter((guest) => guest.type === 'child').length
    },
    notInformed() {
      if (this.isOpened) return 0
      return this.rsvp.guests.filter((guest) => !guest.type).length
    },
    total() {
      return this.adults + this.children + this.notInformed
    },
  },

  data() {
    return {
      show: false,
    }
  },

  methods: {
    showAll() {
      this.show = !this.show
    },
  },
}
</script>

<style lang="scss">
.c-guests {
  color: $neutral;
  padding: 1em 2em;

  > .columns {
    border-bottom: 1px solid $gray-3;

    > .column {
      margin-bottom: 0.5em;
    }

    @media (min-width: $tablet) {
      padding-bottom: 2em;
      > .column {
        margin-bottom: 0;
      }

      > .column.is-hidden-mobile {
        display: block !important;
      }
    }
  }

  &:last-child {
    > .columns {
      border: 0;
    }
  }

  &__link-details {
    display: inline-flex;
    color: $gray-5;
    margin: 1em 0 0;

    > svg {
      margin: 4px 0.5em 1.8em 0;
    }
  }
  &__button-edit {
    width: 64px !important;
  }
  &__edit {
    color: $neutral !important;
    height: 25px;
    border-radius: 8px;
    border: 1px solid #d9e2eb;
    background: $neutrallightest;
    display: flex;
    width: 48px;
    height: 48px;
    cursor: pointer;
    padding: 8px;
    justify-content: center;
    align-items: center;
    color: $neutral;
    &:hover {
      border: 1px solid $neutrallight;
      background: #d9e2eb;
    }
  }
  &__label {
    padding-right: 0.5em;
    margin: 6px 0 0;
    color: $neutral;
    @media (min-width: $tablet) {
      margin: 0;
    }
  }
  &__guest-description-title {
    margin: 0 0 8px;
    font-size: 16px;
    font-weight: bold;
    color: $neutraldarkest;
  }
  &__guest-description {
    font-size: 14px;
    color: $neutral;
  }
}
</style>
